import { useNavigate, useParams } from "react-router-dom";
import { GmailCandidatesPage as GmailCandidatesPageView } from "@/components/GmailCandidatesPage";

export function GmailCandidatesPage() {
  const { connectionId } = useParams<{ connectionId: string }>();
  const navigate = useNavigate();

  if (!connectionId) return null;

  return (
    <GmailCandidatesPageView
      connectionId={connectionId}
      onBack={() => navigate("/settings/integrations/gmail")}
      onGoToBills={() => navigate("/bills")}
      onViewBill={(billId) => navigate(`/bills/${billId}`)}
    />
  );
}
